import React from "react";
import { Link } from "react-router-dom";

export default function TermsPage() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-12 text-slate-800">
      <Link to="/" className="text-emerald-600 font-medium hover:underline">← Retour à l'accueil</Link>
      <h1 className="text-3xl font-bold mt-6 mb-2">Conditions Générales d'Utilisation</h1>
      <p className="text-slate-500 mb-8">Dernière mise à jour : février 2026</p>

      <section className="space-y-6 leading-relaxed">
        <div>
          <h2 className="text-xl font-semibold mb-2">1. Objet</h2>
          <p>
            Les présentes CGU régissent l'utilisation de la plateforme DoctoDays, accessible via
            son site web et ses applications mobiles iOS et Android. DoctoDays est un service de
            mise en relation entre patients et professionnels de santé.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">2. Nature du service</h2>
          <p>
            DoctoDays n'est <strong>pas</strong> un service de téléconsultation, ni un cabinet médical,
            ni un prestataire de soins. DoctoDays ne fournit <strong>aucun avis médical</strong>.
            En cas d'urgence vitale, composez le 15 (SAMU) ou le 112.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">3. Création de compte</h2>
          <p>
            L'utilisation du service nécessite la création d'un compte avec une adresse email valide
            et un mot de passe d'au moins 8 caractères. Chaque utilisateur est responsable de la
            confidentialité de ses identifiants.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">4. Comptes praticiens</h2>
          <p>
            Les professionnels de santé doivent fournir des informations exactes, notamment leur
            spécialité et leur adresse de cabinet. La validation automatique via le numéro RPPS est
            optionnelle ; en son absence, un contrôle manuel par notre équipe peut être requis
            avant l'activation du compte.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">5. Prise de rendez-vous</h2>
          <p>
            Les créneaux proposés sont définis par chaque praticien. Un rendez-vous confirmé peut
            être annulé par le patient ou le praticien jusqu'à son début. En cas d'absence répétée
            et injustifiée, DoctoDays se réserve le droit de suspendre le compte patient.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">6. Avis et notation</h2>
          <p>
            Les patients peuvent laisser un avis (1 à 5 étoiles + commentaire) après une
            consultation. Les avis doivent être respectueux et factuels. DoctoDays se réserve
            le droit de supprimer tout avis diffamatoire, injurieux ou manifestement faux.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">7. Responsabilité</h2>
          <p>
            DoctoDays est tenu à une obligation de moyens concernant la disponibilité du service.
            DoctoDays ne peut être tenu responsable :
          </p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>des informations saisies par les praticiens (horaires, tarifs, spécialité) ;</li>
            <li>des actes médicaux réalisés par les praticiens ;</li>
            <li>des interruptions du service dues à la maintenance ou à un cas de force majeure.</li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">8. Propriété intellectuelle</h2>
          <p>
            Le nom « DoctoDays », le logo et tout le contenu de la plateforme sont protégés. Toute
            reproduction non autorisée est interdite.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">9. Suppression de compte</h2>
          <p>
            Vous pouvez supprimer votre compte à tout moment depuis votre espace ou en écrivant à
            <strong> support@doctodays.com</strong>. Les données seront effacées conformément à la
            <Link to="/privacy" className="text-emerald-600 hover:underline"> politique de confidentialité</Link>.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">10. Droit applicable</h2>
          <p>
            Les présentes CGU sont soumises au droit français. Tout litige sera porté devant les
            juridictions compétentes du ressort du siège social de l'éditeur.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">11. Contact</h2>
          <p>
            Pour toute question relative aux présentes CGU : <strong>support@doctodays.com</strong>
          </p>
        </div>
      </section>
    </div>
  );
}
